Vue.component('v-questions', {
  data: function () {
    return {
      opened: false
    }
  },
  methods: {
    open: function () {
      $(this.$el).css({zIndex: 9999})
      this.opened = true
    },
    close: function () {
      $(this.$el).css({zIndex: 999})
      this.opened = false
    },
    toggle: function () {
      if (this.opened) {
        this.close()
      } else {
        this.open()
      }
    }
  }
})
